import { useSEO } from '../../utils/seo';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ContactPage() {
  useSEO({
    title: "Contact - CoachFit Marseille | Martin Fabrice Coach Sportif",
    description: "Contactez Martin Fabrice, votre coach sportif à Marseille. Coaching à domicile, fitness, musculation. 10 rue Saint Eloi, 13010 Marseille. Consultation gratuite 30min.",
    keywords: "contact coach sportif Marseille, Martin Fabrice, coaching domicile Marseille, fitness Marseille",
    type: "ContactPage"
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-600 to-blue-700 text-white py-20">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/4d3e8d017697198247ddda6564f31b49.jpg')`
          }}
        />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Contactez votre coach sportif
          </h1>
          <p className="text-xl md:text-2xl text-teal-100 max-w-3xl mx-auto">
            Prêt à transformer votre corps ? Contactez Martin Fabrice pour une consultation gratuite de 30 minutes
          </p>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            
            {/* Contact Info */}
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-8">
                  Informations de contact
                </h2>
                
                <div className="space-y-6">
                  {/* Coach Info */}
                  <div className="bg-white p-6 rounded-xl shadow-lg">
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center">
                        <i className="ri-user-line text-teal-600 text-xl"></i>
                      </div>
                      <div className="ml-4">
                        <h3 className="text-xl font-semibold text-gray-900">Martin Fabrice</h3>
                        <p className="text-gray-600">Coach Sportif Professionnel</p>
                      </div>
                    </div>
                    <p className="text-gray-700">
                      Coach sportif certifié avec plus de 10 ans d'expérience. Spécialisé en coaching à domicile, 
                      fitness, musculation et remise en forme personnalisée.
                    </p>
                  </div>

                  {/* Address */}
                  <div className="bg-white p-6 rounded-xl shadow-lg">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-map-pin-line text-blue-600 text-xl"></i>
                      </div>
                      <div className="ml-4">
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">Adresse</h3>
                        <p className="text-gray-700">
                          10 rue Saint Eloi<br />
                          13010 Marseille<br />
                          France
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Email */}
                  <div className="bg-white p-6 rounded-xl shadow-lg">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-green-600 text-xl"></i>
                      </div>
                      <div className="ml-4">
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">Email</h3>
                        <a 
                          href="mailto:fabio-coaching-sportif@hotmail.fr"
                          className="text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
                        >
                          fabio-coaching-sportif@hotmail.fr
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="bg-white p-6 rounded-xl shadow-lg">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                        <i className="ri-phone-line text-purple-600 text-xl"></i>
                      </div>
                      <div className="ml-4">
                        <h3 className="text-lg font-semibold text-gray-900 mb-2">Téléphone</h3>
                        <a 
                          href="tel:0623818989"
                          className="text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
                        >
                          06 23 81 89 89
                        </a>
                        <p className="text-sm text-gray-500 mt-1">
                          Lun-Ven: 7h-20h | Sam: 8h-18h
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Quick Actions */}
              <div className="bg-gradient-to-r from-teal-500 to-blue-600 p-6 rounded-xl text-white">
                <h3 className="text-xl font-semibold mb-4">Actions rapides</h3>
                <div className="space-y-3">
                  <button 
                    onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                    className="w-full bg-white/20 hover:bg-white/30 text-white py-3 px-4 rounded-lg transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-chat-voice-line mr-2"></i>
                    Consultation gratuite (30min)
                  </button>
                  <a 
                    href="/coachs"
                    className="w-full bg-white/20 hover:bg-white/30 text-white py-3 px-4 rounded-lg transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-calendar-line mr-2"></i>
                    Réserver une séance
                  </a>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-8">
                  Localisation
                </h2>
                
                <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2903.8234567890123!2d5.4!3d43.28!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDPCsDE2JzQ4LjAiTiA1wrAyNCcwMC4wIkU!5e0!3m2!1sfr!2sfr!4v1234567890123!5m2!1sfr!2sfr&q=10+rue+Saint+Eloi,+13010+Marseille,+France"
                    width="100%"
                    height="400"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Localisation CoachFit - 10 rue Saint Eloi, Marseille"
                  />
                </div>
              </div>

              {/* Zone d'intervention */}
              <div className="bg-white p-6 rounded-xl shadow-lg">
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  Zone d'intervention
                </h3>
                <p className="text-gray-700 mb-4">
                  Je me déplace dans tout Marseille et ses environs pour vos séances de coaching à domicile.
                </p>
                <div className="grid grid-cols-2 gap-3 text-sm">
                  <div className="flex items-center text-gray-600">
                    <i className="ri-check-line text-teal-600 mr-2"></i>
                    Marseille Centre
                  </div>
                  <div className="flex items-center text-gray-600">
                    <i className="ri-check-line text-teal-600 mr-2"></i>
                    Marseille Nord
                  </div>
                  <div className="flex items-center text-gray-600">
                    <i className="ri-check-line text-teal-600 mr-2"></i>
                    Marseille Sud
                  </div>
                  <div className="flex items-center text-gray-600">
                    <i className="ri-check-line text-teal-600 mr-2"></i>
                    Aix-en-Provence
                  </div>
                  <div className="flex items-center text-gray-600">
                    <i className="ri-check-line text-teal-600 mr-2"></i>
                    Aubagne
                  </div>
                  <div className="flex items-center text-gray-600">
                    <i className="ri-check-line text-teal-600 mr-2"></i>
                    Cassis
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Questions fréquentes
          </h2>
          
          <div className="space-y-6">
            <div className="bg-gray-50 p-6 rounded-xl">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Comment se déroule la consultation gratuite ?
              </h3>
              <p className="text-gray-700">
                La consultation gratuite de 30 minutes permet de faire connaissance, d'évaluer vos objectifs, 
                votre condition physique actuelle et de définir un programme personnalisé adapté à vos besoins.
              </p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-xl">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Quels équipements faut-il avoir à domicile ?
              </h3>
              <p className="text-gray-700">
                Je me déplace avec tout le matériel nécessaire. Vous n'avez besoin que d'un espace de 2x2 mètres 
                et d'une tenue de sport. Je fournis haltères, élastiques, tapis et autres accessoires.
              </p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-xl">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Quels sont vos tarifs ?
              </h3>
              <p className="text-gray-700">
                Les tarifs varient selon le type de coaching et la fréquence des séances. 
                Contactez-moi pour un devis personnalisé adapté à vos objectifs et votre budget.
              </p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-xl">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Proposez-vous des programmes nutrition ?
              </h3>
              <p className="text-gray-700">
                Oui, je propose des conseils nutritionnels personnalisés en complément du coaching sportif 
                pour optimiser vos résultats et adopter une hygiène de vie saine.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-teal-600 to-blue-700 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">
            Prêt à commencer votre transformation ?
          </h2>
          <p className="text-xl text-teal-100 mb-8">
            Contactez-moi dès maintenant pour votre consultation gratuite de 30 minutes
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-chat-voice-line mr-2"></i>
              Consultation gratuite
            </button>
            <a 
              href="mailto:fabio-coaching-sportif@hotmail.fr"
              className="bg-teal-500 hover:bg-teal-400 text-white px-8 py-4 rounded-lg font-semibold transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line mr-2"></i>
              Envoyer un email
            </a>
            <a 
              href="tel:0623818989"
              className="bg-white/20 hover:bg-white/30 text-white px-8 py-4 rounded-lg font-semibold transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer border border-white/30"
            >
              <i className="ri-phone-line mr-2"></i>
              Appeler maintenant
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
